module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAASlJREFUOE9jZKASYKSSOQxDwKB5MbLvGRgYBBj+Mzz4y/DPNnXp0yfEeB/Da3CDQLr//49NWvpkCVkGzY2R2c7IwOgB1vzvr2vSsmd7yDMoWjabkZGh5d/fP5Epy5/vIMYQkBoMr00NFeXhYGO/z/j/X0rSsmcbyTYIpHFejHQ6AwNTw/efPwyzV79+QYxhONPR3Bjp5Yz/GTW+//rpCTNsQaSE9j8WFpG/f37dSF3+6iWyBTgNanBgYJGTkVnOwMBow/Dvb8ZfRsaXzIxMxyGR+f9N8tInokQZBFM0P0Ym/z8DYwMDA8MPBgYGCZh40pLHKI4gKovMDxAQ+MfNm8zIyBDw//9/C5ChyUuf8JLkImwBDTI4ccOHDxQbhM1worxGUfQToxlZDQAvJWAT6fGVfgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/userPage/phone.png
// module id = 6rre
// module chunks = 1